import {
  locationIdFormat,
  transferSessionIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";
import { TransferSessionStatusSchema } from "./transfer-session";

const ActiveTransferSessionSchema_ = z.object({
  transferSessionId: transferSessionIdFormat.schema,
  status: TransferSessionStatusSchema,
  createdAt: z.string(),
  sourceStorageLocationId: z.string(),
  sourceStorageLocationName: z.string(),
  sourceStorageLocationType: z.string(),
  locationId: locationIdFormat.schema,
  sourceTotalItems: z.number(),
  sourceCommittedItems: z.number(),
  sourceExecutedItems: z.number(),
  destinationTotalItems: z.number(),
  destinationCommittedItems: z.number(),
  destinationExecutedItems: z.number(),
});
export const ActiveTransferSessionSchema: z.ZodType<ActiveTransferSession> =
  ActiveTransferSessionSchema_;
export interface ActiveTransferSession
  extends z.infer<typeof ActiveTransferSessionSchema_> {}

export const getActiveUserTransferSessions = {
  name: "getActiveUserTransferSessions" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({ transferSessions: z.array(ActiveTransferSessionSchema) }),
};
